import * as React from "react";
import { TruncatedText } from "./TruncatedText";

export interface DateTextProps
{
    dateString?: string;
};

export const formatDate = (dateString: string | undefined) => {
    if (!dateString) {
        return "";
    }

    const date = new Date(dateString);

    // Get the user's locale (or explicitly use 'de-DE' or 'en-US' for testing)
    const userLocale = navigator.language || 'en-US';

    // Format the date part separately
    const formattedDateTime = new Intl.DateTimeFormat(userLocale, {
        dateStyle: "short",
        timeStyle: "short"
    }).format(date);
    
    return formattedDateTime;
};

export const DateText: React.FC<DateTextProps> = React.memo(({ dateString }) => {
    const formattedDateTime = React.useMemo(() => formatDate( dateString ), [ dateString ]);

    return (
        <TruncatedText text={formattedDateTime} />
    );
});